// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-drawer {\n  height: calc(100vh - 64px) !important;\n}\n.nav-drawer .folder-tree {\n  max-height: 60%;\n  overflow-y: auto;\n}\n@media screen and (max-height: 1000px) {\n.nav-drawer .folder-tree {\n    max-height: 50%;\n}\n}\n@media screen and (max-height: 700px) {\n.nav-drawer .folder-tree {\n    max-height: 25%;\n}\n}", ""]);
// Exports
module.exports = exports;
